import { BsCodeSlash, BsCode } from 'react-icons/bs';
import { Link } from 'react-scroll';
import { FiArrowRight } from 'react-icons/fi';
const Resume = require('../../assets/resume.pdf');

export default function Hero() {
  return (
    <div
      id="hero"
      className="bg-whitish min-h-[93vh] flex items-center justify-center py-8 drop-shadow-md md:px-0 px-4 font-poppins dark:bg-greenish"
    >
      <div className="flex flex-col justify-center items-center py-5">
        <h3 className="text-night md:font-bold font-semibold md:text-5xl text-3xl py-3 text-center dark:text-whitish">
          Hi There 👋 It's Sarah
        </h3>
        <h3 className="text-greenish md:font-semibold font-normal md:text-2xl text-xl py-3 text-center dark:text-beige">
          I'm a
          <BsCode className="md:inline hidden text-greenish w-12 dark:text-beige" />
          <p className="inline italic mx-2 md:mx-0">Front End Web Developer</p>
          <BsCodeSlash className="md:inline hidden text-greenish w-12 dark:text-beige" />
        </h3>
        <h3 className="text-greenish md:font-normal dark:font-thin font-normal md:text-xl text-lg py-1 text-center dark:text-beige w-3/4">
          I'm in love with translating complex technical concepts into visually
          stunning, user-friendly interfaces.
        </h3>
        <button className="bg-greenish md:text-2xl text-xl font-semibold px-3 dark:bg-beige text-beige dark:text-greenish rounded-sm hover:bg-night hover:text-whitish dark:hover:text-night dark:hover:bg-whitish py-1 mt-3">
          <Link
            to="projects"
            spy={true}
            smooth={true}
            delay={50}
            duration={800}
            offset={-100}
          >
            View Projects <FiArrowRight className="inline" />
          </Link>
        </button>
        <button className=" font-semibold px-3  dark:text-beige text-greenish rounded-full hover:underline dark:hover:text-whitish hover:text-night py-1 mt-3">
          <a href={Resume} download="Sarah's Resume">
            Download Resume
          </a>
        </button>
      </div>
    </div>
  );
}
